import axios from 'axios';

export function health() {
    return axios.get('api/healthz/');
}

export function dataHealth() {
    return axios.get('api/data/healthz/');
}
